import useMapStore from "@/store/mapStore";
import { useCallback } from "react";

export const useFetchActiveAds = () => {
  const DBAds = useMapStore((state) => state.DBAds);
  const setAds = useMapStore((state) => state.setAds);

  const fetchActiveAds = useCallback(() => {
    const currentDate = new Date().getTime();
    const activeAds = DBAds.filter((item) => {
      return (
        item.isActive &&
        item.startDate &&
        item.endDate &&
        item.startDate <= currentDate &&
        currentDate <= item.endDate
      );
    });
    setAds(activeAds);
  }, [setAds, DBAds]);

  return { DBAds, fetchActiveAds };
};
